import type { Customer } from './customer'
import type { Provider } from './provider'
import type { User } from './user'

export enum TransportStatus {
    pending = 'pending',
    processing = 'processing',
    accepted = 'accepted',
    declined = 'declined',
    completed = 'completed',
    cancelled = 'cancelled',
}

export enum TransportReason {
    returnHome = 'return_home',
    assessmentAppointment = 'assessment_appointment',
    medicalVisit = 'medical_visit',
    hospitalAppointment = 'hospital_appointment',
}

export enum TransportPosture {
    walksAlone = 'walks_alone',
    needsCane = 'needs_cane',
    needsHelp = 'needs_help',
}

export enum TransportMobility {
    wheelchair = 'wheelchair',
    bedridden = 'bedridden',
}

export enum TransportTripType {
    oneWay = 'one_way',
    roundTrip = 'round_trip',
}

export enum TransportElevator {
    functional = 'functional',
    nonFunctional = 'non_functional',
    none = 'none',
}

export enum LocationType {
    medicalFacility = 'medical_facility',
    residential = 'residential',
}

export interface TransportAddress {
    formatted?: string
    lat?: number
    lng?: number
    provider_place_id?: string
    city?: string
    street?: string
    building?: string
    floor?: string
    narrow_stairs?: boolean
    no_electricity?: boolean
    no_elevator?: boolean
    name?: string
    department?: string
    room?: string
}

export interface Transport {
    id: string
    number: number
    provider_id: string
    provider?: Provider
    customer_id: string
    customer?: Customer
    created_by: string
    creator?: User
    status: TransportStatus

    companion_name?: string
    companion_phone?: string
    companion_relationship?: string

    reason: TransportReason
    reason_details?: string
    appointment_time?: string
    posture?: TransportPosture
    mobility?: TransportMobility
    trip_type: TransportTripType

    origin_hospital?: string
    origin_department?: string
    origin_room?: string

    scheduled_date: string
    scheduled_time: string

    treating_doctor?: string
    has_medical_report: boolean

    departure_address?: TransportAddress
    arrival_address?: TransportAddress

    notes?: string

    estimated_fee?: number
    estimated_fee_override?: boolean
    pickup_type?: LocationType
    dropoff_type?: LocationType

    price?: number
    remarks?: string
    invoice_id?: string

    shared_at?: string
    accepted_at?: string
    declined_at?: string
    completed_at?: string
    cancelled_at?: string
    created_at: string
    updated_at: string
}
